import React, { Component, Fragment } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import {
  Input,
  Icon,
  DatePicker,
  Card,
  Row,
  Col,
  Select,
  Button,
} from "antd";

import { getTermsAndConditions } from '../../../modules/termsandconditions';

import {
  setQuery,
  setRange,
  setStatus,
  setType
} from "../../../modules/search";
import { request } from "../../../utils/http";
import custom from "../../../config/custom";
import _ from "lodash";
import Form from "../../Form";

const { RangePicker } = DatePicker;
const Option = Select.Option;

class SearchBox extends Component {
  constructor(props) {
    super(props);

    this.state = {
      fetchOnClear: false,
      exporting: false,
      types: [],
      downloading: false,
      visible: false,
    };
  }

  componentWillMount() {
    this.mounted = true;

    request(`${custom.baseUrl}/termsandconditionstypes`)
      .then(response => {
        this.setState({
          types: response.data
        });
      })
      .catch(() => {
        //
      });
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  handleDownloadReport = () => {
    this.setState({
      downloading: !this.state.downloading
    });
  };

  componentWillReceiveProps(nextProps) {
    if (this.props.query !== nextProps.query) {
      if (!nextProps.query && this.state.fetchOnClear) {
        this.setState({ fetchOnClear: false }, () => {
          this.search();
        });
      } else if (nextProps.query.match(/(TMS-|([A-Z]{3,}:)).+/i)) {
        this.setState({ fetchOnClear: true }, () => {
          this.search();
        });
      }
    }

    if (this.props.range !== nextProps.range) {
      this.search();
    }
  }

  search = _.debounce(() => {
    this.props.getTermsAndConditions(this.props.page, this.props.pageSize);
  }, 500);

  render() {
    return (
      <Fragment>
        <Card>
          <Row gutter={10} style={{ marginBottom: 10 }}>
            <Col span={16}>
              <Input
                value={this.props.query}
                prefix={<Icon type={"search"} />}
                onChange={e => {
                  this.props.setQuery(e.target.value);
                }}
              />
            </Col>
            <Col span={8}>
              <Button
                style={{ width: "100%" }}
                type="primary"
                icon="plus"
                onClick={() => this.setState({ visible: true })}
              >
                Agregar TyC
              </Button>
            </Col>
          </Row>
          <Row gutter={10}>
            <Col span={8}>
              <Select
                value={this.props.status}
                mode={"multiple"}
                allowClear
                style={{ width: "100%" }}
                placeholder="Estatus"
                onChange={value => {
                  this.props.setStatus(value);
                }}
                disabled
              />
            </Col>
            <Col span={8}>
              <Select
                value={this.props.type}
                mode={"multiple"}
                allowClear
                style={{ width: "100%" }}
                placeholder="Tipo"
                onChange={value => {
                  this.props.setType(value);
                }}
              >
                {this.state.types.map(type => {
                  return (
                    <Option key={type.id} value={type.id}>
                      {type.name}
                    </Option>
                  );
                })}
              </Select>
            </Col>
            <Col span={8}>
              <RangePicker
                style={{ width: "100%" }}
                allowClear={false}
                value={this.props.range}
                onChange={val => {
                  this.props.setRange(val);
                }}
              />
            </Col>
          </Row>
        </Card>
        <Form
          {...this.props}
          model="termsandconditions"
          visible={this.state.visible}
          hide={() => {
            this.setState({ visible: false });
          }}
        />
      </Fragment>
    );
  }
}

const mapStateToProps = state => ({
  query: state.search.query,
  range: state.search.range,
  type: state.search.type,
  status: state.search.status
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setQuery,
      setRange,
      setType,
      setStatus,
      getTermsAndConditions
    },
    dispatch
  );

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(SearchBox)
);



// WEBPACK FOOTER //
// ./src/containers/TermsAndConditionsView/components/SearchBox.js